import { time, Scheduler, store, bridge, coreEngine } from "@dinahmoe/dmafjs-core";
import { WebAudioSound } from "./sound.js";

class WebAudioSoundLoop extends WebAudioSound {
  namespace = "webaudio:sound:loop";

  init(node, event) {
    super.init(node, event);

    node.pendingPlay = new Scheduler(this, this._doPlay);
    node.pendingStop = new Scheduler(this, this._doStop);

    //Chrome m4a reports 17.33333 longer duraction than the actual file duration
    //test if general, if so handle in assetloader
    node.minimumLoopLength = 20;
    node.isPlaying = false;
    node.isFirstLoop = true;
  }

  execute(node, config, event) {
    node.props = config;
    this._play(node, event);
  }

  _play(node, event) {
    //a sound cannot be started on the same event as the audio context is unlocked
    //the webaudio commtext time offset is not set yet which will cause a delay

    if (node.isPlaying) {
      // ignore
      return;
    }

    node.isPlaying = true;

    //coreEngine.update({
    //  uid: node.uid,
    //  key: "assetId",
    //  value: node.props.assetId,
    //});

    const playAtTime = node.props.ignoreEventTime ? time.current : event.time;

    node.pendingStop.clear();
    node.pendingPlay.clear();

    node.pendingPlay.schedule(playAtTime, node, playAtTime);
  }

  stop(node, config, event) {
    node.pendingStop.schedule(event.time, node, event.time, config.fadeOut);
  }

  _doPlay(node, playAtTime) {
    const audioFile = store.get(`assets.buffer.${node.props.assetId}`);
    if (!audioFile) {
      console.error(`audio file ${node.props.assetId} was not loaded, ignoring play`);
      return;
    }

    bridge.update({
      uid: "webaudio/" + node.uid,
      key: "play",
      value: {
        time: playAtTime,
        assetId: node.props.assetId,
        playbackRate: node.props.playbackRate,
        fadeIn: node.isFirstLoop ? node.props.fadeIn : 0,
      },
      sender: "core",
    });
    node.isFirstLoop = false;

    let loopAtTime;
    if (node.props.loopPoint === "start") {
      loopAtTime = playAtTime + node.props.loopOffset;
    } else {
      loopAtTime = playAtTime + audioFile.duration + node.props.loopOffset;
    }
    if (loopAtTime <= playAtTime + node.minimumLoopLength) {
      console.error(
        "loop length is",
        playAtTime + node.minimumLoopLength - loopAtTime,
        "which is below minimumLoopLength, ignoring",
      );
      return;
    }
    node.pendingPlay.schedule(loopAtTime, node, loopAtTime);
  }

  _doStop(node, eventTime, fadeOut) {
    bridge.update({
      uid: "webaudio/" + node.uid,
      key: "stop",
      value: {
        time: eventTime,
        assetId: node.props.assetId,
        fadeOut,
      },
      sender: "core",
    });

    node.isPlaying = false;

    time.schedule(eventTime + fadeOut || 0, () => {
      node.pendingPlay.clear();
      node.pendingStop.clear();
    });
  }
}

const webAudioSoundLoop = new WebAudioSoundLoop();
export { webAudioSoundLoop, WebAudioSoundLoop };
